import HttpClient from '@/lib/HttpClient';
export default {
  getAll() {
    return HttpClient.getAuthenticated(`/api/admin/users`);
  },
  getInactiveUsers() {
    return HttpClient.getAuthenticated(`/api/admin/users/inactive`);
  },
  getAllCustomerUsers(customerId) {
    return HttpClient.getAuthenticated(`/api/admin/customers/${customerId}/users`);
  },
  getProjects(userId) {
    return HttpClient.getAuthenticated(`/api/admin/users/${userId}/projects`);
  },
  getById(id) {
    return HttpClient.getAuthenticated(`/api/admin/users/${id}`);
  },
  getAllByProjectId(projectId) {
    return HttpClient.getAuthenticated(`/api/admin/projects/${projectId}/users`);
  },
  getUserInfo() {
    return HttpClient.getAuthenticated(`/api/userinfo`);
  },
  getIdPInfoById(userId) {
    return HttpClient.getAuthenticated(`/api/admin/users/${userId}/idpinfo`);
  },
  create(record) {
    return HttpClient.postAuthenticated(`/api/admin/users`, {
      ...record
    });
  },
  update(record) {
    return HttpClient.updateAuthenticated(`/api/admin/users/${record.DbId}`, {
      record
    });
  },
  delete(record) {
    return HttpClient.deleteAuthenticated(`/api/admin/users/${record.UserId}`, {
      record
    });
  },
  block(userId) {
    return HttpClient.getAuthenticated(`/api/admin/users/${userId}/block`);
  },
  unblock(userId) {
    return HttpClient.getAuthenticated(`/api/admin/users/${userId}/unblock`);
  },
  assignToCustomerAdmins(userToAdd, accountId) {
    return HttpClient.postAuthenticated(`/api/admin/customers/${accountId}/admins`, userToAdd);
  },
  deleteFromCustomerAdmins(userId, accountId) {
    return HttpClient.deleteAuthenticated(`/api/admin/customers/${accountId}/admins/${userId}`);
  },
  getAssignedAccounts(userId) {
    return HttpClient.getAuthenticated(`/api/admin/users/${userId}/accounts`);
  },
  async resetPassword(userId) {
    return HttpClient.getAuthenticated(`/api/admin/users/${userId}/resetpassword`);
  },
  async inviteToBauvisor(userId) {
    return HttpClient.getAuthenticated(`/api/admin/users/${userId}/invite?to=app`);
  },
  async inviteToAdmin(userId) {
    return HttpClient.getAuthenticated(`/api/admin/users/${userId}/invite?to=admin`);
  }
};
